// increment by 0.1 max 0.90
const version = '1.34.0'

export default version
